import { motion } from "framer-motion";
import styles from "./Switch.module.scss";
import { useRef } from "react";

const spring = { type: "spring", stiffness: 300, damping: 40 };

function PlansTypeSwitch({ dictionary, isAnnuallyOn, setIsAnnuallyOn }) {
	const toggleSwitch = () => setIsAnnuallyOn(!isAnnuallyOn);
	const [monthlyRef, annuallyRef] = [useRef(null), useRef(null)];

	return (
		<div className={styles.container}>
			<div className={styles.wrapper} onClick={toggleSwitch} data-ison={!isAnnuallyOn}>
				<button ref={monthlyRef} className={`${styles.value} ${!isAnnuallyOn ? styles.active : undefined}`} onClick={() => setIsAnnuallyOn(false)}>
					{dictionary["monthly"] || "Monthly"}
				</button>
				<motion.div className={styles.motion} layout transition={spring} style={{ minWidth: isAnnuallyOn ? annuallyRef?.current?.offsetWidth + 20 : monthlyRef?.current?.offsetWidth + 20 }} />
				<button ref={annuallyRef} data-sale={dictionary["50% off"] || "50% off"} className={`${styles.value} ${isAnnuallyOn ? styles.active : undefined}`} onClick={() => setIsAnnuallyOn(true)}>
					{dictionary["annually"] || "Yearly"} - 50%
				</button>
			</div>
		</div>
	);
}

export default PlansTypeSwitch;
